<template>
  <div class="signup app-content bg-gray">
    <div class="bg-gray pb-5">
      <div class="container bg-gray">
        <div class="row mx-0 pb-2">
          <div class="col-12 p-0">
            <router-link :to="'./mypage'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.top")}}</p>
            </router-link>
            <p class="mx-1 text-dark font14" style="display: inline;"> > </p>
            <router-link :to="'./threads'">
              <p class="text-dark font14 under" style="display: inline;">{{$t("message.threads")}}</p>
            </router-link>
          </div>
        </div>
        <div class="row pt-4 mb-2">
          <div class="col-6">
            <h3 class="pt-3">{{$t("message.threads")}}</h3>
          </div>
          <div class="col-6 py-2 text-right">
            <b-button  class="next py-2 px-4" @click='showCreateModal()'> {{$t("message.create_thread")}}</b-button>
          </div>
          <div class="col-12 py-2">
              <b-list-group>
                <div v-for="board in getItems" :key="board.id">
                  <b-list-group-item class='my-2'>
                    <div class="row">
                      <div class="col-12">
                        {{$t("message.nickname")}} : {{board.nickname}}
                      </div>
                      <div class="col-sm-12 col-md-10 thread-title">
                        <router-link :to="'./thread/' + board.id">
                          <b class="black">{{board.title}}</b>
                        </router-link>
                      </div>
                      <div class="col-sm-12 col-md-2 thread-date">
                        {{ $t("message.updated_at")}} : {{format_day(board.updated_at)}}
                      </div>
                    </div>
                  </b-list-group-item>
                </div>
              </b-list-group>
              <div class="col-6 col-md-2 mx-auto">
               <paginate
                :page-count="getPageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'＜'"
                :next-text="'＞'"
                :container-class="'pagination'"
                :page-class="'page-item' "
                :page-link-class="'page-link'"
                :prev-class="'page-item'"
                :prev-link-class="'page-link'"
                :next-class="'page-item'"
                :next-link-class="'page-link'"
                >
              </paginate>
              </div>
          </div>
        </div>

      </div>
    </div>
    <b-modal v-model="createModal " hide-footer hide-header size="md">
      <template>
        <div class="row mb-3">
          <div class="col-12">
            <h4 class="text-center mt-3">{{$t("message.create_thread")}}</h4>
          </div>
        </div>

        <validation-observer class="form" ref="obs" >
          <div class="row">
            <div class="col-10 ml-3 mt-3">
              <p class="pt-2 ml-4 pl-4 mb-0">{{$t("message.nickname")}}</p>
            </div>
            <div class="col-9 mx-auto text-center">
              <input class="simple-input p-2 width100" v-model="thread_info.nickname">
            </div>
          </div>
          <div class="row">
            <div class="col-10 ml-3 mt-4">
              <p class="pt-2 ml-4 pl-4 mb-0">{{$t("message.thread_title")}}</p>
            </div>
            <div class="col-9 mx-auto text-center">
              <validation-provider name="title" rules="required">
                <div slot-scope="TitleProps">
                  <input class="simple-input p-2 width100" v-model="thread_info.title">
                  <p v-if="TitleProps.failed" class="error text-left">{{ TitleProps.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="row">
            <div class="col-10 ml-3 mt-4">
              <p class="pt-2 ml-4 pl-4 mb-0">{{$t("message.content")}}</p>
            </div>
            <div class="col-9 mx-auto text-center">
              <validation-provider name="contents" rules="required">
                <div slot-scope="ContentProps">
                  <input class="simple-input p-2 width100" v-model="thread_info.contents">
                  <p v-if="ContentProps.failed" class="error text-left">{{ ContentProps.errors[0] }}</p>
                </div>
              </validation-provider>
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-12 text-center">
              <b-button  class="next" @click="createThreads">
                {{$t("message.create")}}
              </b-button>
            </div>
          </div>
        </validation-observer>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import Paginate from 'vuejs-paginate'
import { ValidationProvider, ValidationObserver} from "vee-validate";

export default {
  components: {
    Paginate,
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      occupation: undefined,
      board_list: [],
      idToken: localStorage.idToken,
      parPage: 10,
      currentPage: 1,
      meta: {},
      createModal: false,
      thread_info: {
        title: '',
        contents: '',
        nickname: ''
      }
    }
  },
  methods: {
    createThreads(){
      if(this.thread_info.nickname == ''){
        this.thread_info.nickname = 'unknown'
      }
      axios
      .post(process.env.VUE_APP_API + "/boards/", {board: this.thread_info}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.hideCreateModal()
        this.board_list.push(response.data)
      }).catch(() => {
      })
    },
    showCreateModal(){
      this.createModal = true
    },
    hideCreateModal(){
      this.createModal = false
    },
    clickCallback: function (pageNum) {
      this.currentPage = Number(pageNum);
    },
    fetch_board: function() {
      var lang = ''
      if(this.language == 'kh'){
        lang = 'km'
      }else if(this.language == 'lk'){
        lang = 'si'
      }else{
        lang = this.language
      }
      axios
      .get(process.env.VUE_APP_API + "/boards?lang=" + lang ,{headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.board_list = response.data.boards
        this.meta = response.data.meta
      }).catch(error => {
        console.log('this is error', error)
      })
    },
  },
  async mounted() {
    if( this.memberInfo.status == 'associate_member'){
      this.$router.push('./createUser')
    }else{
      if (this.memberInfo.status == "no_deposite_member") {
        //this.$router.push('./payment')
      }
    }
    this.fetch_board()
    this.$store.commit('setLoading', false)
  },

  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    }),
    getItems: function() {
      let current = this.currentPage * this.parPage;
      let start = current - this.parPage;
      console.log(this.board_list)
      return this.board_list.slice(start, current);
    },
    getPageCount: function() {
      return Math.ceil(this.meta.total / this.parPage);
    }
  }
}
</script>

<style scoped lang="scss">
.thread-title{
  font-size: 1.3rem;
}
.black{
  color: #000000;
}
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
.thread-date {
  font-size: 0.9rem;
}
</style>
